import { render } from "./PopupContent.vue?vue&type=template&id=38130e73"
import script from "./PopupContent.vue?vue&type=script&lang=js"
export * from "./PopupContent.vue?vue&type=script&lang=js"

import "./PopupContent.vue?vue&type=style&index=0&id=38130e73&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__